import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';

import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { ISharedWithMeContentInfo } from '../models/ISharedWithMeContentInfo';
import { GetSharedWithMeRequest } from '../serverApi/requests/GetSharedWithMeRequest';

class SharedWithMeService {

  private getSharedWithMeContentInfo = new WebClientListResourceFetcher(GetSharedWithMeRequest, ServerApiMapper.sharedWithMe);

  public getSharedWithMe(): ResourceQuery<ISharedWithMeContentInfo> {
    return new ResourceQuery(this.getSharedWithMeContentInfo);
  }
}

export const SharedWithMe = new SharedWithMeService();
